import { apiClient } from "@base/api/client";
import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

export const modifierSchema = z.object({
  id: z.number(),
  name: z.string(),
  avatar_url: z.string().nullable(),
});

export const dailyLogLockStatusSchema = z.discriminatedUnion("locked", [
  z.object({
    locked: z.literal(true),
    locked_at: z.string(),
    remaining_ttl_seconds: z.number(),
    modifier: modifierSchema,
  }),
  z.object({
    locked: z.literal(false),
    locked_at: z.null(),
    remaining_ttl_seconds: z.null(),
    modifier: z.null(),
  }),
]);

export type DailyLogLockStatus = z.infer<typeof dailyLogLockStatusSchema>;

async function fetchDailyLogLockStatus(projectId: string, logId: string): Promise<DailyLogLockStatus> {
  const response = await apiClient.get(`/project-management/api/projects/${projectId}/daily-logs/${logId}/lock`);
  return dailyLogLockStatusSchema.parse(response.data);
}

export function dailyLogLockStatusQueryOptions(projectId: string, logId: string) {
  return {
    queryKey: ["daily-log-lock-status", projectId, logId] as const,
    queryFn: () => fetchDailyLogLockStatus(projectId, logId),
    staleTime: 0,
  };
}

export function useDailyLogLockStatusQuery(projectId: string, logId: string) {
  return useQuery(dailyLogLockStatusQueryOptions(projectId, logId));
}
